export default class StringUtils{

  /**
   * Removes all whitespace characters from the provided string.
   *
   * @param stringWithWhitespaces Input string from which all whitespaces should be removed
   * @return String representing the provided string with all whitespace characters removed
   */
  public static removeAllWhitespaces(stringWithWhitespaces: string | undefined): string{
    if(!stringWithWhitespaces){
      return '';
    }
    return stringWithWhitespaces.replace(/\s+/g, '');
  }

  /**
   * Determines if two strings, after removing all whitespace characters, are equal.
   *
   * @param value1 First string to compare
   * @param value2 Second string to compare
   * @return True if both provided string are equal after removing all whitespace characters else false
   */
  public static compareValuesWithoutWhitespaces(value1: string | undefined, value2: string | undefined): boolean{
    return this.removeAllWhitespaces(value1) === this.removeAllWhitespaces(value2);
  }

  public static getDomainFromUrl(url: string): string | null {
    try {
      if (url.startsWith('//')) { // edge case for urls without protocol
        url = 'http:' + url;
      }
      const parsedUrl = new URL(url);
      return parsedUrl.hostname;
    } catch (error) {
      console.error('Invalid URL:', error);
      return null;
    }
  }
}
